import styled from 'styled-components';

const DailyCalendarWrapper = styled.div`
    position: relative;
    /* Daily Calendar Component - optimized for time-based event display */
    .rbc-calendar {
        min-height: ${(props) => (props.minHeight ? props.minHeight : 'calc(100vh - 16rem)')};

        .rbc-time-view {
            border: none;

            //background color for today's date
            .rbc-today {
                background-color: #fff !important;
            }

            .rbc-time-header {
                /* DAILY DRAWER: Different from base - header at top with shadow */
                position: ${(props) => (props.$noHeader ? 'relative' : 'sticky')};
                top: ${(props) => (props.$noHeader ? '0' : '8rem')};
                box-shadow: ${(props) => (props.$noHeader ? 'none' : '0px 3px 15px rgba(0, 0, 0, 0.4)')};
                background-color: #fff;
                z-index: ${(props) => (props.$noHeader ? 'auto' : '1002')};

                .rbc-time-header-content {
                    border-left: none;

                    .rbc-allday-cell {
                        .rbc-row {
                            /* DAILY DRAWER: Larger allday row */
                            min-height: 4rem;
                            .rbc-event {
                                .rbc-event-content {
                                    height: auto;
                                    min-height: 0;
                                    .event {
                                        /* DAILY DRAWER: Larger event height */
                                        height: 3.8rem;
                                        overflow: hidden;

                                        margin-top: 2px;

                                        .event-content {
                                            min-height: 0;
                                            padding: 0 0 0.4rem 0.3rem;
                                            overflow: hidden;
                                            margin-right: 0.3rem;

                                            .event-content-top {
                                                padding: 0.2rem 0.1rem 0 0;
                                                div {
                                                    font-size: 0.6rem;
                                                    span {
                                                        display: block;
                                                    }
                                                }
                                            }

                                            .event-title {
                                                font-size: 0.8rem;
                                                line-height: 1.1em;
                                                height: 0.95rem;
                                                padding-top: 0.1rem;
                                                svg {
                                                    font-size: 0.75rem;
                                                }
                                            }
                                            .event-subtitle {
                                                display: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .rbc-time-content {
                /* DAILY DRAWER: visible overflow and no max-height */
                overflow-y: visible;
                max-height: none;

                .rbc-time-gutter {
                    /* DAILY DRAWER: Wider gutter for better time labels */
                    min-width: 6rem;
                }

                .rbc-day-slot {
                    .rbc-timeslot-group {
                        border-bottom: 1px solid rgba(221, 221, 221, 0.3);
                    }
                }

                .rbc-time-column {
                    .rbc-timeslot-group {
                        /* DAILY DRAWER: Taller time slots (60px per hour) */
                        min-height: 60px;
                        .rbc-time-slot {
                            .rbc-label {
                                /* DAILY DRAWER: Larger time labels */
                                font-size: 1.1rem;
                                font-weight: 600;
                                display: block;
                                padding: 0.25rem 0.5rem;
                                line-height: 1em;
                            }
                        }
                    }
                }

                .rbc-events-container {
                    div.rbc-event {
                        /* CRITICAL FIX: Remove !important to allow react-big-calendar inline styles */
                        /* height: auto; - DO NOT SET THIS, let react-big-calendar control it */
                        overflow: visible;
                        display: block;

                        /* DAILY DRAWER: Enhanced visual styling */
                        box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.4);
                        border-radius: 0.5rem;

                        &:focus {
                            outline: none !important;
                        }

                        .rbc-event-label {
                            display: none;
                        }

                        .rbc-event-content {
                            /* DAILY DRAWER: Content fills the react-big-calendar calculated height */
                            height: 100%;

                            .event {
                                /* DAILY DRAWER: Event fills content and no border */
                                height: 100%;
                                border: none !important;
                            }
                        }

                        //separate cancelled events
                        &.cancelled {
                            /* DAILY DRAWER: Simpler cancelled styling */
                            opacity: 0.6;
                            ::before {
                                content: '';
                                display: none;
                                padding-bottom: 0;
                                padding-top: 0;
                            }
                        }
                    }
                }
            }
        }
    }

    .fixed-loading-container {
        width: 100%;
        position: absolute;
        z-index: 9999;
        top: 20rem;
        text-align: center;
    }

    .general-calendar {
        position: relative;
        padding-bottom: 1em;
        width: 100%;
        transition: all 300ms ease-out;
        background: white;

        .calendar {
            width: 100%;
            transition: all 300ms ease-out;
        }
    }

    .loading-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 4;
    }

    .rbc-event {
        padding: 0.3em;
        border-radius: 4px;
        border: none !important;
        transition: all 300ms ease-out;
        overflow: hidden;
        background-color: transparent;
        padding: 0;
        font-size: 0.95rem;

        &.event-fade {
            opacity: 0.4 !important;
        }

        .event {
            border-left: 1px solid #fff;
            &.event-first-day {
                border-top-left-radius: 0.5rem;
                border-bottom-left-radius: 0.5rem;
            }

            &.event-last-day {
                border-top-right-radius: 0.5rem;
                border-bottom-right-radius: 0.5rem;
            }
        }
    }

    .rbc-current-time-indicator {
        display: none !important;
    }
`;

export default DailyCalendarWrapper;
